import React from 'react';
import { useLanguage } from '../../contexts/LanguageContext';
import { EXPERIENCE_DATA } from '../../constants';
import TimelineItem from '../TimelineItem/TimelineItem';
import content from '../../i18n/content';
import './Experience.css';

export default function Experience() {
  const { lang } = useLanguage();
  const t = content[lang].experience;

  return (
    <section id="experience" className="experience-section">
      <h2>{t.sectionTitle}</h2>
      {EXPERIENCE_DATA.map((entry) => {
        const copy = t.items[entry.id];
        return (
          <TimelineItem
            key={entry.id}
            title={copy.title}
            subtitle={copy.organization}
            period={entry.period}
          >
            <ul className="experience-achievements">
              {copy.achievements.map((line, index) => (
                <li key={index}>{line}</li>
              ))}
            </ul>
            <p className="experience-stack">
              <strong>{t.stackLabel}</strong> {entry.stack.join(', ')}
            </p>
          </TimelineItem>
        );
      })}
    </section>
  );
}
